export default "__VITE_ASSET__AqruLldh__"